import { AvailableProductTrialType } from '../types/AvailableProductTrialType';
import { GzLandingPageProductLinks } from '../../common/gzLandingPage/view/gzLandingPageConfig/gz-landing-page-links';
import { InProductTrialsOverlayWindowType } from '../inProductTrialsOverlayWindow/types/InProductTrialsOverlayWindowType';

export const IN_PRODUCT_TRIALS_TRACKING_NAME = 'product trials';

export function getGzLandingPageProductLinkWithTracking(type: AvailableProductTrialType, buttonId: string): string {
  const pageLink = GzLandingPageProductLinks[type];
  return pageLink.link + `?icid=button|b|${pageLink.id}|${buttonId}`;
}

export function trackDismissActionIfWelcomeBanner(type: InProductTrialsOverlayWindowType) {
  if (type !== InProductTrialsOverlayWindowType.ProductTrialsHubNewSection) {
    return;
  }

  analytics.trackPageInteraction({
    reference: IN_PRODUCT_TRIALS_TRACKING_NAME + ':banner',
    asset: 'dismiss',
  });
}
